import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/site_logo/XNQ.svg";
import MobileMenu from "../MobileMenu/MobileMenu";
import icon1 from '../../images/icons/icon_mail.svg';
import { useLocation } from "react-router-dom";


const Header = (props) => {
const location = useLocation();
const isKodoPage = location.pathname === "/kodo-program";

  const [mobailActive, setMobailState] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const kodoButtonStyle = {
  background: isKodoPage
    ? "linear-gradient(to right, #3ddc91, #00a86b)" // Green
    : "linear-gradient(to right, #3893FF, #7CACFC, #5086F8)", // Blue
  color: "#fff",
  border: "none",
};

const defaultButtonStyle = {
  background: "linear-gradient(to right, #3893FF, #7CACFC, #5086F8)", // Always blue
  color: "#fff",
  border: "none",
};


  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  // const [hover, setHover] = useState(false);

  // const handleMouseEnter = () => setHover(true);
  // const handleMouseLeave = () => setHover(false);

  const spanStyle = {
     background: isKodoPage
      ? "linear-gradient(to right, #3ddc91, #00a86b)" // green gradient
      : "linear-gradient(to right, #3893FF, #7CACFC, #5086F8)", // default blue gradient
    color: "#fff"
  };

  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
 <header
  className="site_header site_header_1">

      <div
  className="header_top text-center"
  style={{
    background: isKodoPage
      ? "linear-gradient(to right, #3ddc91, #00a86b)"
      : "linear-gradient(to right, #3893FF, #7CACFC, #5086F8)",
    color: "#fff",
  }}
  
>
        <div className="container">
          <p className="m-0">
            <strong>Limited Seats</strong> : Kodo Program Commences On
            <b> August 18, 2025</b>.{" "}
            <Link onClick={ClickHandler} to="/contact">
              <u>Apply Now</u> <i className="fa-solid fa-angle-right"></i>
            </Link>
          </p>
        </div>
      </div>
      <div
        className={`header_bottom stricky  ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-3 col-lg-3 col-md-4 col-5">
              <div className="site_logo">
                <Link onClick={ClickHandler} className="site_link" to="/">
                  <img
                    src={logo}
                    alt="Site Logo"
                  />
                </Link>
                <div className="badge bg-danger-subtle text-danger">
                  Exclusive
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-2 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className="main_menu_inner collapse navbar-collapse justify-content-lg-center d-none d-lg-block"
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list justify-content-center">
                    <li className="">
                      <Link
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/"
                        // id="home_submenu"
                        // role="button"
                        // data-bs-toggle="dropdown"
                        // aria-expanded="false"
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/about">
                        About Us
                      </Link>
                    </li>

                    <li className="dropdown">
                      <Link
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/Service-Home"
                        // id="home_submenu"
                        // role="button"
                        // data-bs-toggle="dropdown"
                        // aria-expanded="false"
                      >
                        Service
                      </Link>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="home_submenu"
                      >
                        {/* <li><Link onClick={ClickHandler} to="/Service-Home">Service Home</Link></li> */}
                        <li>
                          <Link onClick={ClickHandler} to="/service-XnovaQ">
                            Direct Hire Staffing
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="/Contingent-Staffing"
                          >
                            Contingent Staffing
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="/Recruitment-Process"
                          >
                            Recruitment Process Outsourcing
                          </Link>
                        </li>
                        {/* <li><Link onClick={ClickHandler} to="">Near Shore Staffing</Link></li> */}
                      </ul>
                    </li>
                
                    {/* <li>
                      <Link onClick={ClickHandler} to="/course">
                        Courses
                      </Link>
                    </li> */}

                  </ul>
                </div>
              </nav>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-5">
              <ul className="header_btns_group unordered_list justify-content-end d-flex flex-row gap-2">
                <li>
                  <button
                    className="mobile_menu_btn"
                    onClick={() => setMobailState(!mobailActive)}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#main_menu_dropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </li>
                <li>
                 <Link
  onClick={ClickHandler}
  className="btn nav-button"
  to="/kodo-program"
  style={kodoButtonStyle}
>
  <span className="btn_label" data-text={isMobile ? "Kodo" : "Kodo Program"}>
    <span className={isMobile ? "mobile-label" : "desktop-label"}>
      {isMobile ? "Kodo" : "Kodo Program"}
    </span>
  </span>
</Link>

                </li>

                <li>
                  <Link
  onClick={ClickHandler}
  className="btn d-md-none d-lg-block nav-button"
  to="/lets-talk"
  style={defaultButtonStyle}
>
  <span className="btn_label" data-text="Let's Talk">
    Let's Talk
  </span>
  <span className="btn_icon ms-2">
    <img src={icon1} alt="mail" />
  </span>
</Link>

                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mobail-wrap">
          <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
            <div className="xb-header-menu-scroll">
              <div
                className="xb-menu-close xb-hide-xl xb-close"
                onClick={() => setMobailState(!mobailActive)}
              ></div>
              <nav className="xb-header-nav">
                <MobileMenu />
              </nav>
            </div>
          </div>
          <div
            className="xb-header-menu-backdrop"
            onClick={() => setMobailState(false)}
          ></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
